import React, { useState } from "react";
import { Box } from "@mui/system";
import { SubTabName } from "pages/authenticated/dashboardv2/types";
import { AllowedValuesDTO, CollectorDTO, ConfigParameterDTO, DefaultChartDTO, SiteDTO } from "api";
import { DashboardTabs } from "components";
import { AllSelects } from "../components";
import SubTab from "../subTab";

export const MainTab = ({
  currentMainTab,
  tabs,
  allowedValues,
  sitesData,
  configParameter,
  collectorsData,
  fiscalYears
}: {
  currentMainTab: string;
  tabs: SubTabName[];
  allowedValues: AllowedValuesDTO | undefined;
  sitesData: SiteDTO[] | undefined;
  configParameter: ConfigParameterDTO[] | undefined;
  collectorsData: CollectorDTO[] | undefined;
  fiscalYears: string[]
}) => {

  const [searchFilters, setSearchFilters] = useState<DefaultChartDTO>({
    countryRegions: null,
    countries: null,
    siteIds: null,
    facilityTypes: null,
    businessUnits: null,
    scopes: null,
    utilityTypeIds: null,
    accountNumbers: null,
    meterNumbers: null,
  });

  const initialTab = tabs[0];

  const setSearchFiltersPreservingSubTab = (newFilters: DefaultChartDTO) => {
    setSearchFilters(prev => ({
      ...newFilters,
      utilityTypeIds: newFilters.utilityTypeIds ?? prev.utilityTypeIds,
    }));
  };

  const allTabs = tabs.map((tab) => ({
    label: tab,
    content: <SubTab
      currentMainTab={currentMainTab}
      subTypeChart={tab.toLowerCase()}
      setSearchFilters={setSearchFilters}
      searchFilters={searchFilters}
      fiscalYears={fiscalYears}
    >
      <AllSelects
        setSearchFilters={setSearchFiltersPreservingSubTab}
        currentMainTab={currentMainTab}
        allowedValues={allowedValues}
        sitesData={sitesData}
        configParameter={configParameter}
        collectorsData={collectorsData}
      />
    </SubTab>
  }))

  return (
    <Box sx={{ my: 2 }}>
      <DashboardTabs intensity tabs={allTabs} selectedBtnOption={initialTab} textColor="#99CD71" dashboard />
    </Box>
  )
}
